import { MAXIMUM_HEIGHT, MAXIMUM_WIDTH } from "first-animation/screen";
import * as PIXI from "pixi.js";
import { sprite } from "./sprite";
export class Grey {
    constructor(app) {
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0x000000, 1);
        graphics.drawRect(0, 0, MAXIMUM_WIDTH, MAXIMUM_HEIGHT);
        graphics.endFill();
        this.texture = app.renderer.generateTexture(graphics);
        this.sprite = sprite.fromTexture(this.texture);
    }
}
//# sourceMappingURL=grey.js.map